<template>
  <div class="filter-bar" :class="{ 'filter-bar--compact': compact }">
    <div class="filter-bar__group filter-bar__group--dates">
      <div class="filter-bar__field filter-bar__field--date">
        <span v-if="!compact" class="filter-bar__label">From</span>
        <div class="filter-bar__control filter-bar__control--date">
          <DatePicker
            compact
            class="filter-bar__date-picker"
            :value="DateStart"
            placeholder="From"
            :max-date="maxDate"
            :clearable="false"
            :validate="false"
            @input="setStartDate"
          />
        </div>
      </div>
      <div class="filter-bar__field filter-bar__field--date">
        <span v-if="!compact" class="filter-bar__label">To</span>
        <div class="filter-bar__control filter-bar__control--date">
          <DatePicker
            compact
            class="filter-bar__date-picker"
            :value="DateEnd"
            placeholder="To"
            :limit="EndDateLimit"
            :min-date="DateStart"
            :max-date="maxDate"
            :clearable="false"
            :validate="false"
            @input="setEndDate"
          />
        </div>
      </div>
    </div>

    <div class="filter-bar__field filter-bar__field--status">
      <span v-if="!compact" class="filter-bar__label">Status</span>
      <div class="filter-bar__control filter-bar__control--select">
        <Multiselect
          v-model="status"
          class="filter-bar__multiselect"
          selectLabel=""
          :options="computedStatusTypes"
          :placeholder="statusPlaceholder"
          track-by="name"
          label="Value"
          @input="SelectedStatus"
        >
          <span slot="noResult">No status found.</span>
          <template slot="singleLabel" slot-scope="{ option }">
            {{ option.Value }}
          </template>
        </Multiselect>
      </div>
    </div>

    <div class="filter-bar__actions">
      <button
        type="button"
        class="filter-bar__btn filter-bar__btn--apply"
        @click="Filterticket"
      >
        Apply
      </button>
      <button
        type="button"
        class="filter-bar__btn filter-bar__btn--clear"
        @click="ClearFilter"
      >
        Clear
      </button>
    </div>
  </div>
</template>

<script>
import { DatePicker } from '@/components/base/index';
import moment from 'moment';
import Multiselect from 'vue-multiselect';
import { toApiDate } from '@/utils/datehelper';

export default {
  props: {
    statusOptions: {
      type: Array,
      default: null,
    },
    statusPlaceholder: {
      type: String,
      default: 'Payment Status',
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchTicket: null,
      status: null,
      DateStart: null,
      DateEnd: null,
      maxDate: new Date(),
      EndDateLimit: [
        {
          type: 'weekday',
          available: [0, 1, 2, 3, 4, 5, 6],
        },
        {
          type: 'weekend',
          available: [1, 2],
        },
        {
          type: 'fromto',
          from: moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD'),
        },
      ],
      StatusTypes: [
        { name: 'pending', Value: 'Pending' },
        { name: 'partially_paid', Value: 'Partially Paid' },
        { name: 'paid', Value: 'Paid' },
        { name: 'cancelled', Value: 'Cancelled' },
      ],
    };
  },
  computed: {
    computedStatusTypes() {
      return Array.isArray(this.statusOptions) && this.statusOptions.length
        ? this.statusOptions
        : this.StatusTypes;
    },
  },
  components: {
    DatePicker,
    Multiselect,
  },
  created() {
    const today = moment().format('YYYY-MM-DD');
    this.DateStart = this.toPickerDate(today);
    this.DateEnd = this.toPickerDate(today);
    this.$emit('StartDate', today);
    this.$emit('EndDate', today);
  },
  methods: {
    toPickerDate(value) {
      const api = toApiDate(value);
      return moment(api, 'YYYY-MM-DD').toDate();
    },
    emitDates(start, end) {
      const s = toApiDate(start);
      const e = toApiDate(end, s);
      this.DateStart = this.toPickerDate(s);
      this.DateEnd = this.toPickerDate(e);
      this.$emit('StartDate', s);
      this.$emit('EndDate', e);
    },
    Filterticket() {
      this.emitDates(this.DateStart, this.DateEnd);
      this.$emit('Status', this.status || { name: '' });
      this.$emit('FilterQuery');
    },
    setStartDate(value) {
      if (!value) return;
      const start = toApiDate(value);
      this.DateStart = this.toPickerDate(start);
      this.$emit('StartDate', start);
      if (this.DateEnd && toApiDate(this.DateEnd) < start) {
        this.DateEnd = this.toPickerDate(start);
        this.$emit('EndDate', start);
      }
    },
    setEndDate(value) {
      if (!value) return;
      const end = toApiDate(value);
      this.DateEnd = this.toPickerDate(end);
      this.$emit('EndDate', end);
    },
    SelectedStatus(event) {
      this.$emit('Status', event || { name: '' });
    },
    ClearFilter() {
      this.searchTicket = '';
      const today = moment().format('YYYY-MM-DD');
      this.status = null;
      this.emitDates(today, today);
      this.$emit('Status', { name: '' });
      this.$emit('clearFilter', '');
    },
  },
};
</script>

<style scoped>
.filter-bar {
  display: grid;
  grid-template-columns: minmax(168px, 180px) minmax(168px, 180px) minmax(
      200px,
      1fr
    ) auto auto;
  align-items: end;
  gap: 10px;
  width: 100%;
  max-width: 100%;
}

.filter-bar__group--dates {
  display: contents;
}

.filter-bar__field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.filter-bar__label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #64748b;
  line-height: 1;
  white-space: nowrap;
}

.filter-bar__control {
  height: 36px;
  width: 100%;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
  overflow: hidden;
  box-sizing: border-box;
}

.filter-bar__control--date {
  overflow: visible;
  min-width: 168px;
}

.filter-bar__control--select {
  height: 36px;
  padding: 0;
  overflow: hidden;
}

.filter-bar__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.filter-bar__btn {
  height: 36px;
  min-width: 88px;
  padding: 0 16px;
  border-radius: 8px;
  border: none;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.filter-bar__btn--apply {
  background: var(--brand-primary, #512d82);
  color: #ffffff !important;
}

.filter-bar__btn--clear {
  background: #ffffff;
  color: var(--brand-primary, #512d82) !important;
  border: 1px solid #e2e8f0;
}

/* Compact: one tight row — dates | status | buttons (no huge gap) */
.filter-bar--compact {
  display: grid;
  grid-template-columns: 150px 150px minmax(140px, 1fr) auto;
  align-items: center;
  gap: 8px;
}

.filter-bar--compact .filter-bar__group--dates {
  display: contents;
}

.filter-bar--compact .filter-bar__field {
  flex-direction: column;
  gap: 0;
  min-width: 0;
}

.filter-bar--compact .filter-bar__field--date {
  width: 150px;
  max-width: 150px;
}

.filter-bar--compact .filter-bar__control {
  height: 32px;
  overflow: visible;
}

.filter-bar--compact .filter-bar__control--date {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  overflow: visible;
}

.filter-bar--compact .filter-bar__field--status {
  min-width: 0;
}

.filter-bar--compact .filter-bar__control--select {
  height: 32px;
}

.filter-bar--compact .filter-bar__actions {
  display: flex;
  align-items: center;
  gap: 6px;
  justify-self: end;
}

.filter-bar--compact .filter-bar__btn {
  height: 32px;
  min-width: 72px;
  padding: 0 14px;
  font-size: 13px;
}

.filter-bar--compact ::v-deep .filter-bar__date-picker,
.filter-bar--compact ::v-deep .filter-bar__date-picker.kot-date-picker,
.filter-bar--compact ::v-deep .filter-bar__date-picker .vd-wrapper,
.filter-bar--compact ::v-deep .filter-bar__date-picker .vd-activator {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
}

.filter-bar--compact ::v-deep .vd-picker__input {
  min-height: 32px !important;
  height: 32px !important;
  width: 100% !important;
  overflow: visible !important;
}

.filter-bar--compact ::v-deep .vd-picker__input-icon {
  flex: 0 0 22px !important;
  margin: 0 !important;
  padding: 0 !important;
}

.filter-bar--compact ::v-deep .vd-picker__input-icon__wrapper {
  width: 22px !important;
  min-width: 22px !important;
}

.filter-bar--compact ::v-deep .vd-picker__input input {
  flex: 1 1 auto !important;
  width: 1% !important;
  min-width: 6.5em !important;
  max-width: 100% !important;
  min-height: 32px !important;
  height: 32px !important;
  line-height: 32px !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  padding: 0 2px !important;
  margin: 0 !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

.filter-bar--compact ::v-deep .filter-bar__multiselect,
.filter-bar--compact ::v-deep .filter-bar__multiselect .multiselect__tags {
  min-height: 32px !important;
  height: 32px !important;
}

.filter-bar--compact ::v-deep .filter-bar__multiselect .multiselect__single,
.filter-bar--compact ::v-deep .filter-bar__multiselect .multiselect__placeholder {
  line-height: 32px !important;
  font-size: 13px !important;
}

.filter-bar--compact ::v-deep .filter-bar__multiselect .multiselect__select {
  height: 32px !important;
}

@media (max-width: 720px) {
  .filter-bar--compact {
    grid-template-columns: 1fr 1fr;
  }

  .filter-bar--compact .filter-bar__field--status {
    grid-column: 1 / -1;
  }

  .filter-bar--compact .filter-bar__field--date,
  .filter-bar--compact .filter-bar__control--date {
    width: 100%;
    min-width: 0;
  }

  .filter-bar--compact .filter-bar__actions {
    grid-column: 1 / -1;
    justify-content: flex-end;
  }
}

@media (max-width: 400px) {
  .filter-bar--compact {
    grid-template-columns: 1fr;
  }
}

/* Default (non-compact) deep styles */
.filter-bar:not(.filter-bar--compact) ::v-deep .filter-bar__control > div {
  width: 100%;
  height: 100%;
}

.filter-bar ::v-deep .vd-wrapper,
.filter-bar ::v-deep .vd-picker__input {
  width: 100%;
  height: 100%;
  min-height: 28px;
}

.filter-bar ::v-deep .vd-picker__input {
  display: flex;
  align-items: center;
}

.filter-bar ::v-deep .vd-picker__input input {
  flex: 1 1 auto !important;
  width: 1% !important;
  min-width: 6.5em !important;
  margin: 0 !important;
  padding: 0 2px !important;
  border: none !important;
  color: #1e293b !important;
  text-align: left !important;
  background: transparent !important;
  box-shadow: none !important;
}

.filter-bar ::v-deep .filter-bar__multiselect {
  display: block;
  width: 100%;
  min-height: 28px;
  font-size: 12px;
}

.filter-bar ::v-deep .filter-bar__multiselect .multiselect__tags {
  position: relative;
  width: 100%;
  min-height: 28px;
  height: 28px;
  margin: 0;
  padding: 0 28px 0 8px;
  border: none;
  border-radius: 8px;
  background: #ffffff;
  box-sizing: border-box;
}

.filter-bar ::v-deep .filter-bar__multiselect .multiselect__single,
.filter-bar ::v-deep .filter-bar__multiselect .multiselect__placeholder {
  position: absolute;
  left: 8px;
  right: 28px;
  top: 0;
  margin: 0;
  padding: 0;
  font-size: 12px;
  font-weight: 600;
  line-height: 28px;
  color: #334155;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.filter-bar ::v-deep .filter-bar__multiselect .multiselect__placeholder {
  color: #94a3b8;
  font-weight: 500;
}

.filter-bar ::v-deep .filter-bar__multiselect .multiselect__select {
  top: 0;
  right: 0;
  width: 28px;
  height: 28px;
}

.filter-bar ::v-deep .filter-bar__multiselect .multiselect__option--highlight,
.filter-bar ::v-deep .filter-bar__multiselect .multiselect__option--highlight::after {
  background: var(--brand-primary, #512d82) !important;
}

@media (max-width: 991px) {
  .filter-bar:not(.filter-bar--compact) {
    grid-template-columns: 1fr 1fr;
  }

  .filter-bar:not(.filter-bar--compact) .filter-bar__field--status {
    grid-column: 1 / -1;
  }

  .filter-bar:not(.filter-bar--compact) .filter-bar__actions {
    grid-column: 1 / -1;
    justify-content: flex-end;
  }
}
</style>
